import { Builder } from '@builder.io/react'
import React from 'react'

import BlueTick from '../../../images/builder/BlueTick.svg'
import differentDog from '../../../images/builder/DDog_Logo2.svg'
import PinkCross from '../../../images/builder/PinkCross.svg'

import './index.css'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'

interface Competitor {
  name: string
  code: string
  cloudinaryLogo: any
  builderLogo: any
  altText: string
}

interface Availability {
  compCode: string
  isBool: boolean
  availabilityText: string
  availability: boolean
  featureText: string
}

interface Feature {
  featureName: string
  availability: Availability[]
}

interface Props {
  competitors: Competitor[]
  features: Feature[]
  backgroundColor: string
  featureTextColor: string
  borderColor: string
  cloudinaryDesktopLogo: any
  builderDesktopLogo: any
  availableFeatureAltText: string
  unavailableFeatureAltText: string
}

interface AvailabilityRow {
  index: number
  competitor: Competitor
  feature: Feature
  featureTextColor: string
  borderColor: string
  widthSize: string
  availableFeatureAltText: string
  unavailableFeatureAltText: string
}

const DesktopRow = ({
  index,
  competitor,
  feature,
  featureTextColor,
  widthSize,
  availableFeatureAltText = '',
  unavailableFeatureAltText = ''
}: AvailabilityRow) => {
  const availabilityItem: Availability | any = feature.availability.find(a => a.compCode === competitor.code)

  return (
    <td
      key={index}
      // style={{ width: widthSize }}
      style={{ minWidth: widthSize }}
      className={`max-w-[150px] p-2 text-center sm:py-5 md:px-6`}
    >
      {!availabilityItem?.isBool ? (
        <span className="block text-sm text-gray-700" style={{ color: featureTextColor }}>
          {availabilityItem?.availabilityText}
        </span>
      ) : (
        <div className={`flex items-center ${index === 0 ? 'justify-center lg:justify-start' : 'justify-center'}`}>
          {availabilityItem.availability ? (
            <img
              src={BlueTick}
              alt={availableFeatureAltText}
              className={`${index === 0 ? 'h-12 w-12 sm:mr-2 sm:h-8 sm:w-8 md:mr-4' : 'h-8 w-8'}`}
              style={{ minWidth: index === 0 ? '2rem' : 'auto', maxWidth: index === 0 ? '2rem' : 'auto' }}
              loading="lazy"
            />
          ) : (
            <img
              src={PinkCross}
              alt={unavailableFeatureAltText}
              className={`${index === 0 ? 'h-12 w-12 sm:mr-2 sm:h-8 sm:w-8 md:mr-4' : 'h-8 w-8'}`}
              style={{ margin: '0 auto' }}
              loading="lazy"
            />
          )}
          <span className="hidden text-left text-sm sm:block">
            {index === 0 ? availabilityItem.featureText || 'Best dog food' : ''}
          </span>
        </div>
      )}
    </td>
  )
}

const ComparisonTable = ({
  competitors,
  features,
  backgroundColor,
  featureTextColor,
  borderColor,
  cloudinaryDesktopLogo,
  builderDesktopLogo,
  availableFeatureAltText = '',
  unavailableFeatureAltText = ''
}: Props) => {
  const getWidthClass = () => {
    const num = competitors.length < 4 ? 4 : competitors.length + 1
    return `${100 / num}%`
  }

  const widthSize = getWidthClass()

  // hidden lg:block
  return (
    <div className="my-4 bg-white" style={{ backgroundColor }}>
      <div className="mx-auto w-full max-w-7xl bg-white py-4 sm:px-6 lg:px-8" style={{ backgroundColor }}>
        {/* xs to lg temporarily hidden */}
        {/* <div className="max-w-2xl mx-auto space-y-16 lg:hidden">
          {competitors?.map((comp, i) => (
            <section key={i}>
              <div className="px-4 mb-8">
                <img src={comp.logo || 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1637560612299x182190235043719460%2FDD_Logo.cmyk.png?w=64&h=&auto=compress&dpr=1&fit=max'} alt={comp.name} className='full-width' />
              </div>

                <table key='feature-mobile-table' className="w-full">
                  <thead>
                    <tr>
                      <th className="sr-only" scope="col">
                        Feature
                      </th>
                      <th className="sr-only" scope="col">
                        Included
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {features?.map((feature, j) => (
                      <MobileRow index={j} competitor={comp} feature={feature} featureTextColor={featureTextColor} borderColor={borderColor} />
                    ))}
                  </tbody>
                </table>

            </section>
          ))}
        </div> */}

        {/* lg+ hidden lg:block*/}
        <div className="comparisonTable">
          <table className="h-px w-full">
            <caption className="sr-only">Feature comparison</caption>
            <thead>
              <tr className="column-limiter">
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900" scope="col">
                  <span className="sr-only">Feature by</span>
                </th>
                {competitors?.map((comp, i) => (
                  <th
                    key={i}
                    className={`py-4 text-center text-lg font-medium leading-6 text-gray-900 sm:px-6`}
                    scope="col"
                    style={{ maxWidth: '200px' }}
                  >
                    <div className={`mx-auto  block`}>
                      <CdnImage
                        className="m-auto block md:hidden"
                        url={comp.builderLogo}
                        alt={comp.altText}
                        steps={[100, 180]}
                        style={{
                          width: 'auto',
                          height: 'auto',
                          dpr: 'auto'
                        }}
                      />
                      {/* {comp.builderLogo ? (
                        <CdnImage
                          className="m-auto block md:hidden"
                          url={comp.builderLogo}
                          alt={comp.altText}
                          steps={[100, 180]}
                          style={{
                            width: 'auto',
                            height: 'auto',
                            dpr: 'auto'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className={'m-auto block md:hidden'}
                          publicId={comp?.cloudinaryLogo?.public_id}
                          alt={comp.altText}
                          steps={[100, 180]}
                          style={{
                            width: 'auto',
                            height: 'auto',
                            dpr: 'auto'
                          }}
                        />
                      )} */}
                      <CdnImage
                        className={'m-auto hidden md:block'}
                        url={builderDesktopLogo}
                        alt={comp.altText}
                        steps={[100, 180]}
                        style={{
                          width: '100%',
                          height: 'auto',
                          dpr: 'auto'
                        }}
                      />

                      {/* {builderDesktopLogo ? (
                        <CdnImage
                          className={'m-auto hidden md:block'}
                          url={builderDesktopLogo}
                          alt={comp.altText}
                          steps={[100, 180]}
                          style={{
                            width: '100%',
                            height: 'auto',
                            dpr: 'auto'
                          }}
                        />
                      ) : (
                        <CloudinaryImage
                          className="m-auto hidden md:block"
                          publicId={i === 0 ? cloudinaryDesktopLogo?.public_id : comp?.cloudinaryLogo?.public_id}
                          alt={comp.altText}
                          steps={[100, 180]}
                          style={{
                            width: '100%',
                            height: 'auto',
                            dpr: 'auto'
                          }}
                        />
                      )} */}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 border-t border-gray-200" style={{ borderColor: borderColor }}>
              {features?.map((feature, i) => (
                <tr key={i} style={{ borderColor: borderColor }} className="column-limiter">
                  <th
                    className={`max-w-[150px] p-2 text-left text-sm font-normal text-gray-500 sm:w-auto sm:py-5 sm:px-6 sm:text-base`}
                    scope="row"
                    style={{ color: featureTextColor, minWidth: widthSize }}
                  >
                    {feature.featureName}
                  </th>
                  {competitors.map((comp, j) => (
                    <DesktopRow
                      index={j}
                      competitor={comp}
                      feature={feature}
                      featureTextColor={featureTextColor}
                      borderColor={borderColor}
                      widthSize={widthSize}
                      availableFeatureAltText={availableFeatureAltText}
                      unavailableFeatureAltText={unavailableFeatureAltText}
                    />
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ComparisonTable

Builder.registerComponent(ComparisonTable, {
  name: 'ComparisonTable',
  inputs: [
    {
      name: 'competitors',
      type: 'list',
      defaultValue: [{ name: 'Different', code: 'different_dog', logo: null, altText: '' }],
      subFields: [
        { name: 'name', type: 'string', defaultValue: 'Different Dog' },
        {
          name: 'code',
          type: 'string',
          defaultValue: 'different_dog',
          helperText: 'This value should be used to link features in the feature set'
        },
        { name: 'cloudinaryLogo', type: 'cloudinaryImageEditor' },
        {
          name: 'builderLogo',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        { name: 'altText', type: 'text', defaultValue: '' }
      ]
    },
    {
      name: 'features',
      type: 'list',
      subFields: [
        { name: 'featureName', type: 'string', defaultValue: 'Frozen for freshness' },
        {
          name: 'availability',
          type: 'list',
          subFields: [
            { name: 'compCode', type: 'string', defaultValue: 'different_dog' },
            { name: 'isBool', type: 'boolean', defaultValue: true },
            { name: 'availabilityText', type: 'string', defaultValue: 'N/A' },
            { name: 'availability', type: 'boolean', defaultValue: true },
            { name: 'featureText', type: 'string', defaultValue: 'Best Dog Food' }
          ],
          defaultValue: [
            {
              compCode: 'different_dog',
              isBool: true,
              availabilityText: 'N/A',
              availability: true,
              featureText: 'Best Dog Food'
            }
          ]
        }
      ],
      defaultValue: [
        {
          featureName: 'Frozen for freshness',
          availability: [
            {
              compCode: 'different_dog',
              isBool: true,
              availabilityText: 'N/A',
              availability: true,
              featureText: 'Best Dog Food'
            }
          ]
        }
      ]
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'featureTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'borderColor',
      type: 'color',
      defaultValue: 'gray'
    },
    // {
    //   name: 'cloudinaryDesktopLogo',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderDesktopLogo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'availableFeatureAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'unavailableFeatureAltText',
      type: 'text',
      defaultValue: ''
    }
  ]
})
